import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { hasRequiredRole, ROLES } from "../../lib/roles";

export default function ProtectedRoute({ 
  children, 
  requiredRole = ROLES.CLIENT,
  redirectTo = "/login/employee" 
}) {
  const { user, loading, role, roleLoading } = useAuth();

  if (loading || roleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!hasRequiredRole(role, requiredRole)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
          <p className="text-muted-foreground">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            Required role: {requiredRole} | Your role: {role || "none"}
          </p>
        </div>
      </div>
    );
  }

  return children;
}

export function EmployeeRoute({ children }) {
  return (
    <ProtectedRoute requiredRole={ROLES.EMPLOYEE} redirectTo="/login/employee">
      {children}
    </ProtectedRoute>
  )
}

export function ClientRoute({ children, redirectTo = "/login/client" }) {
  return (
    <ProtectedRoute requiredRole={ROLES.CLIENT} redirectTo={redirectTo}>
      {children}
    </ProtectedRoute>
  )
}

export function AdminRoute({ children }) {
  return (
    <ProtectedRoute requiredRole={ROLES.ADMIN} redirectTo="/login/employee">
      {children}
    </ProtectedRoute>
  )
}

